/* eslint-disable */
<template>
	<div class="uploadWrap">
		<div class="upload" v-show="uploaded">

			<div class="upload-title">
				<div style="color:#888;margin-top: 0px;">
					<a :href="showText" target="_blank" >
						{{ showText }}
					</a>
				</div>
			</div>
		</div>
		<div class="upload" v-show="(!uploaded&&!fileList.length)">
			<input type="file" class="fileUp" id="file" :accept="acceptTypes">

			<div class="upload-title">
				<div><i class="el-icon-upload" style="color:#6e5ef5;font-size:20px"></i></div>
				<div style="color:#888;margin-top: 10px;">
          {{!startUpload ? `点击或者拖拽视频到这里上传` : `正在上传到服务器${process}%`}}
          </div>
			</div>
		</div>
		<div class="imgWrap" v-for="item in fileList" :key="item.src">
			<!-- <img :src="item.src" @load="revokeSrc(item.src)"> -->
			<div class="lefticon"><i class="el-icon-upload" style="color:#6e5ef5;font-size:20px"></i></div>
			<div>
				<div class="name">{{item.name}} </div>
				<span>{{item.progress}} %</span>
				<div class="bar" :style="`width:${item.progress}%`"></div>
				<!-- <span class="cancle" @click="removeImg(item)">×</span> -->
			</div>
			<!-- <span v-if="item.isFinished||item.isFail" :class="['flag',item.isFail?'redBd':(item.isFinished?'greenBd':'')]">
				<span>{{item.isFail?'✗':(item.isFinished?'✓':'')}}</span>
			</span> -->
		</div>
	</div>
</template>

<script scoped>
import { fetchFileToken } from '@/ajax/index';
import baidubce from '@baiducloud/bos-uploader';
import axios from 'axios';
/* eslint-disable */
// 请求队列
let cbList = [];
// 过滤不符合条件的文件
function filterFiles(files, fileTypes, maxSize) {
	return files.filter(file => {
		let index = file.name.lastIndexOf('.');
		let ext = file.name.slice(index + 1);
		// if (fileTypes.includes(ext) && file.size <= maxSize * 1024 * 1024) {
		if (fileTypes.includes(ext) ) {
			return true;
		} else {
			return false;
		}
	}
	)
}
// 格式化文件名
function formatName(filename) {
	let lastIndex = filename.lastIndexOf('.');
	let suffix = filename.slice(0, lastIndex);
	let fileName = suffix + new Date().getTime() + filename.slice(lastIndex);
	return {
		suffix,
		fileName
	}
}
// 请求
function Ajax(options) {
	// 合并
	console.log('postType:',options.type,options.path);

	// let url = 'http://192.168.90.101:8098/admin/ar/video/';
	let url = '/admin/ar/video/';
	switch(options.type)
	{
		case 0:
		break;
		case 1:
			url = '/admin/ar/semantics/';
		break;
		case 2:
			url = '/admin/ar/location_video/';
		break;
	}


	options = Object.assign({
		url: url,
		path: '/',
		method: 'POST',
		progress: Function.prototype
	}, options);
	// 返回Promise
	return new Promise((resolve, reject) => {
		let xhr = new XMLHttpRequest;

		xhr.upload.onprogress = e => {
			options.progress(e, xhr);
		}
		xhr.open(options.method, options.url + options.path);
		xhr.setRequestHeader("Content-Type", "video/mp4");
		xhr.send(options.data);
		xhr.onreadystatechange = () => {
			if (xhr.readyState === 4) {
				if (/^(2|3)\d{2}$/.test(xhr.status)) {
					resolve(JSON.parse(xhr.responseText));
				} else {
					this.$message.basic('请求已中断 -- ',xhr.readyState);
					reject({ msg: "请求已中断" });
				}
			}
		}
	})
}


export default {
	name: 'upload',
	props: {
		itemData: { type: Object, default: null },
		itemNum:{type:Number,default:0},
		maxSize: {
			type: Number,
			default: 2
		},
		postType:{type:Number,default:""},
		fileTypes: {
			type: Array,
			default: () => ['MP4','mp4']
		}
	},
	data() {
		return {
      startUpload: false,
      process: 0,
			fileList: [],
			maxLen: 6,
			finishCnt: 0,
			showText:'点击或者拖拽视频到这里上传',
			uploaded:false,
		}
	},
	mounted() {
    this.uploadFile();
		if(null===this.itemData)return;
		if(null!=this.itemData.videos[this.itemNum]&&this.postType==="")
		{
			// console.log(this.itemData.videos[this.itemNum]);
			this.uploaded = true;
			this.showText = this.itemData.videos[this.itemNum];
		}
  	},
	methods: {
    async sleep(timeout = 3000) {
      await new Promise(resolve => {
        setTimeout(() => {
          resolve();
        }, timeout);
      })
    },
    checkFileExit() {
      axios.head(this.url)
      .then(async () => {
        await this.sleep(500);
        this.$emit('finishUpload', this.url);
      }, () => {
        this.checkFileExit();
      });
    },
    uploadFile() {
      this.uploader = new baidubce.bos.Uploader({
        browse_button: '#file',
        max_file_size: '5000M',
        chunk_size: "20M",
        bos_multipart_min_size: '40M',
        auto_start: true,
        init: {
          UploadComplete: () => {
            this.process = '90';
            this.startUpload = false;
            this.$message({
              message: "上传完成",
              type: "success"
            });
          },
          FileUploaded: (_, file, info) => {
            // 文件上传成功之后，调用这个函数
            // var url = [site, info.body.key].join('/');
            this.process = 1;
            this.$message({
              message: "上传成功",
              type: "success"
            });
            this.url = `${this.site}/${this.key}`;
            this.checkFileExit();
          },
          Error: (_, error, file) => {
            this.$message({
              message: "上传失败",
              type: "fail"
            });
          },
          Key: async (_, file) => {
            const filename = file.name;
            this.startUpload = true;
            console.log(119999900, file);
            if (!file.type.includes('video')) {
              return this.$message({
                type: 'fail',
                message: "请上传视频"
              })
            };
            console.log(1199999, file);
            const {data} = await fetchFileToken(filename);
            this.site = data.data.site;
            this.key = data.data.key;
            this.bos_endpoint = data.data.endpoint;
            this.uploader.setOptions({
              bos_ak: data.data.ak,
              bos_sk: data.data.sk,
              uptoken: data.data.uptoken,
              bos_endpoint: data.data.endpoint,
              bos_bucket: data.data.bucket_name,
            })
            this.uploader.start();
            return this.key;
          },
          NetworkSpeed: (_, bytes, time, pendings) => {
            console.log('progress', _, bytes, time, pendings);
            this.process = Math.floor(100 * (bytes / (pendings + bytes))) || 0;
          },
        },
      });
    },
		//上传
		uploadChange(e) {
			// return;
			console.log('postType:',this.postType,this.fileTypes);
			let files = filterFiles([...e.target.files], this.fileTypes, this.maxSize);//过滤
			this.fileList = this.fileList.concat(files.map((file, index) => {
				// 创建
				let newFile = {};
				newFile.name = file.name;
				newFile.orgname = file.name;
				newFile.isFinished = false;
				newFile.src = window.URL.createObjectURL(file);
				newFile.progress = 0;
				newFile.abort = false;
				newFile.imgSrc = " ";
				newFile.isFail = false;
				// 设置formDate
				let fd = new FormData();
				fd.append('file', file);
				let { fileName, suffix } = formatName(file.name);
				fd.append('fileName', fileName);
				fd.append('suffix', suffix);
				// 加入请求队列
				let path = this.itemData.ar_id+'/'+fileName;

					switch(this.postType)
					{
						case 0:
						break;
						case 1:
						break;
						case 2:
							path = this.itemData.uid+'/'+fileName;
						break;
					}

				let cb = () => {
					this.maxLen++;
					return Ajax({
						path: path,
						data: file,
						that:this,
						type:this.postType,
						progress: (e, xhr) => {
							newFile.progress = Math.floor(e.loaded / e.total * 90);
							if(newFile.progress===90){
								newFile.name+=' 服务器上传中..';
							}
							// 中断
							if (newFile.abort) {

								this.$message.basic('上传被中断!');
								xhr.abort();
							}
						}
					}).then(res => {
						// 存url
						newFile.imgSrc = res.src;
						newFile.isFinished = true;
						// 状态改变通知
						this.finishCnt++;
						this.fileListChange();
					}, err => {
						newFile.isFail = true;
					}).finally(() => {
						this.maxLen++;
						this.request();
					});
				}
				cbList.push(cb);
				this.request();
				return newFile;
			}));
		},
		//请求
		request() {
			while (this.maxLen > 0 && cbList.length) {
				let cb = cbList.shift();
				this.maxLen--;
				cb();
			}
		},
		// 移除url缓存
		revokeSrc(url) {
			window.URL.revokeObjectURL(url);
		},
		// 删除图片
		removeImg(item) {
			item.abort = true;
			let index = this.fileList.indexOf(item);
			if (index !== -1) {
				this.fileList.splice(index, 1);
				this.fileListChange();
			}
		},
		// 上传成功数量变化
		fileListChange() {
			this.$emit('fileListChange', this.fileList);
			if (this.finishCnt === this.fileList.length) {
				this.$emit('finishUpload', this.fileList);
				this.fileList[0].progress = 100;
				this.fileList[0].name = this.fileList[0].orgname+' 上传完成 ';
			}
		}
	},
	computed: {
		// 设置文件类型
		acceptTypes() {
			return this.fileTypes.map(type => ("video/*" + type)).join(',');
		}
	}
}
</script>

<style lang="scss" scoped>
/* 上传 */
.uploadWrap {
	transition: all 0.5s ease-in-out;
	-webkit-user-select: none; /*webkit浏览器*/
	-ms-user-select: none; /*IE10*/
	-khtml-user-select: none; /*早期浏览器*/
	user-select: none;
	position: relative;
	box-sizing: border-box;
	padding: 5px;
}
.fileUp {
	opacity: 0;
	position: absolute;
	width: 100%;
	height: 100%;
}
.upload {

	margin: 10px 0;
	width: 100%;
	height: 120px;
	box-sizing: border-box;
	border: 1px solid #c4d0dc;
	position: relative;
	border-radius: 5px;
	display: flex;
	overflow: hidden;

	> div {
		text-align: center;
		margin-top: 30px;
		width: 100%;
	}

	button {
		border: none;
		border-radius: 2px;
		box-sizing: border-box;
		padding: 5px 10px;
		color: white;
		outline: none;
		cursor: pointer;
	}
}
/* 提示 */
.tips {
	display: inline-block;
	font-size: 10px;
	color: #6b6972;
}
/* 图片 */
.imgWrap {
	margin: 10px 0;
	width: 100%;
	height: 120px;
	box-sizing: border-box;
	padding: 10px;
	border: 1px solid #c4d0dc;
	position: relative;
	border-radius: 5px;
	display: flex;
	overflow: hidden;
	img {
		display: block;
		width: 80px;
		height: 80px;
		object-fit: cover;
		border-radius: 5px;
	}

	.lefticon {
		width: 26px;
		font-size: 15px;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		padding-left: 10px;
		color: #647090;
	}

	> div {
		font-size: 15px;
		display: flex;
		// align-items: center;
		flex-direction: column;
		justify-content: space-around;
		width: 100%;
		padding-left: 10px;
		color: #647090;

		.name {
			overflow: hidden;
			width: 100%;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		.bar {
			width: 200px;
			height: 5px;
			background-color: #409eff;
			border-radius: 5px;
		}
	}
	.cancle {
		color: #999;
		font-size: 25px;
		position: absolute;
		right: 4px;
		top: -4px;
	}
	&:hover .flag {
		display: none;
	}
}
/* 勾 */
.flag {
	position: absolute;
	width: 0px;
	height: 0px;
	border: 20px solid #13ce66;
	top: 0;
	right: 0;
	font-size: 14px;
	color: white;
	cursor: pointer;
	span {
		position: absolute;
		font-size: 20px;
		right: -16px;
		top: -22px;
	}
}
.redBd {
	border-color: orangered orangered transparent transparent;
}
.greenBd {
	border-color: #15d169 #15d169 transparent transparent;
}
</style>
